import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/eleva/Header';
import { Hero } from './components/eleva/Hero';
import { Services } from './components/eleva/Services';
import { WhyEleva } from './components/eleva/WhyEleva';
import { Process } from './components/eleva/Process';
import { Portfolio } from './components/eleva/Portfolio';
import { Testimonials } from './components/eleva/Testimonials';
import { FAQ } from './components/eleva/FAQ';
import { Contact } from './components/eleva/Contact';
import { Footer } from './components/eleva/Footer';

const Landing = () => {
  return (
    <div className="grain relative bg-brand-bg text-white min-h-screen overflow-x-hidden" data-testid="eleva-landing">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyEleva />
        <Process />
        <Portfolio />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
